/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Bookora API
 * API for **bookora.net** — multi-tenant SaaS for Iranian beauty clinics and
 * aesthetic doctors.
 *
 * ## Conventions
 *
 * - **Versioning**: customer-facing routes live under `/api/v1/...`. The health
 *   probes (`/health`, `/ready`) are unprefixed and version-neutral.
 * - **Response envelope**: every successful JSON response is
 *   `{ "data": <payload>, "meta"?: <extra> }`.
 * - **Error envelope**: every error response is
 *   `{ "statusCode": number, "code": string, "message": string, "details"?: any, "requestId"?: string }`.
 *   `code` is a stable token from `ErrorCode`; `message` is finished Persian copy.
 * - **Pagination**: list endpoints take 1-indexed `?page=&pageSize=` and return
 *   `{ items, page, pageSize, total, pageCount }` inside `data`.
 * - **Auth**: bearer JWT. Tokens come from `/api/v1/auth/otp/verify` and rotate on
 *   `/api/v1/auth/refresh`. There are no passwords in this product.
 * - **Tenancy**: the access token carries the clinic. Every tenant-scoped query is
 *   filtered by it server-side; a `clinicId` in a path or body must agree with the
 *   token or the request is rejected.
 * - **Currency**: every money field is an integer in **rials**. Panels display
 *   toman (1 toman = 10 rials).
 * - **Quantities**: integer milli-units (`…Milli`, 1 unit = 1000).
 *   **Percentages**: basis points (`…PercentBp`, 1% = 100).
 * - **Timestamps**: UTC ISO-8601. Jalali conversion happens in the UI.
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AdjustLotDto,
  CountLotsDto,
  InventoryLotsListParams,
  LotCountResultResponse,
  LotListResponse,
  LotResponse,
  ReceiveLotDto,
  ReceiveMoreLotDto,
  ReturnLotDto,
  SetLotQuarantineDto,
  UpdateLotDto,
  WriteOffLotDto
} from '../model';

import { apiClient } from '../../mutator';




const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * مرتب‌شده بر اساس نزدیک‌ترین انقضا (بچ‌های بدون انقضا در انتها) — همان ترتیبی که FEFO برای مصرف پیشنهاد می‌دهد.
 * @summary فهرست بچ‌ها
 */
export const inventoryLotsList = (
    params?: InventoryLotsListParams,
 signal?: AbortSignal
) => {


      return apiClient<LotListResponse>(
      {url: `/api/v1/inventory/lots`, method: 'GET',
        params, signal
    },
      );
    }




export const getInventoryLotsListQueryKey = (params?: InventoryLotsListParams,) => {
    return [
    `/api/v1/inventory/lots`, ...(params ? [params] : [])
    ] as const;
    }


export const getInventoryLotsListQueryOptions = <TData = Awaited<ReturnType<typeof inventoryLotsList>>, TError = void>(params?: InventoryLotsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof inventoryLotsList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInventoryLotsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof inventoryLotsList>>> = ({ signal }) => inventoryLotsList(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof inventoryLotsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type InventoryLotsListQueryResult = NonNullable<Awaited<ReturnType<typeof inventoryLotsList>>>
export type InventoryLotsListQueryError = void


export function useInventoryLotsList<TData = Awaited<ReturnType<typeof inventoryLotsList>>, TError = void>(
 params: undefined |  InventoryLotsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof inventoryLotsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof inventoryLotsList>>,
          TError,
          Awaited<ReturnType<typeof inventoryLotsList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useInventoryLotsList<TData = Awaited<ReturnType<typeof inventoryLotsList>>, TError = void>(
 params?: InventoryLotsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof inventoryLotsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof inventoryLotsList>>,
          TError,
          Awaited<ReturnType<typeof inventoryLotsList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useInventoryLotsList<TData = Awaited<ReturnType<typeof inventoryLotsList>>, TError = void>(
 params?: InventoryLotsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof inventoryLotsList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary فهرست بچ‌ها
 */

export function useInventoryLotsList<TData = Awaited<ReturnType<typeof inventoryLotsList>>, TError = void>(
 params?: InventoryLotsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof inventoryLotsList>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getInventoryLotsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * مقدار را یا با packageCount (تعداد بسته) یا با quantityReceivedMilli بفرستید، و مبلغ را یا با pricePerPackageRials یا با purchasePriceRials — نه هر دو. بهای هر واحد از روی همین دو عدد محاسبه و روی بچ ثبت می‌شود و فقط با خرید تازهٔ همان سری (receive-more) به میانگین وزنی تغییر می‌کند؛ مصرف‌های گذشته بهای خودشان را نگه می‌دارند. batchNo اختیاری است: خالی یعنی سرور شمارهٔ NB-<تاریخ شمسی>-<n> می‌سازد. یک گردش انبار از نوع PURCHASE و (به‌صورت پیش‌فرض) یک هزینهٔ «خرید مواد» هم ثبت می‌شود؛ بهای تمام‌شده از هزینه خوانده نمی‌شود بلکه از مصرف جلسه می‌آید تا دوباره‌شماری رخ ندهد.
 * @summary ثبت ورود کالا (خرید جدید)
 */
export const inventoryLotsReceive = (
    receiveLotDto: ReceiveLotDto,
 signal?: AbortSignal
) => {


      return apiClient<LotResponse>(
      {url: `/api/v1/inventory/lots`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: receiveLotDto, signal
    },
      );
    }




export const getInventoryLotsReceiveMutationKey = () => ['inventoryLotsReceive'] as const;

export const getInventoryLotsReceiveMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof inventoryLotsReceive>>, TError,InventoryLotsReceiveMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof inventoryLotsReceive>>, TError,InventoryLotsReceiveMutationVariables, TContext> => {

const mutationKey = getInventoryLotsReceiveMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof inventoryLotsReceive>>, InventoryLotsReceiveMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  inventoryLotsReceive(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type InventoryLotsReceiveMutationResult = NonNullable<Awaited<ReturnType<typeof inventoryLotsReceive>>>
    export type InventoryLotsReceiveMutationBody = ReceiveLotDto
    export type InventoryLotsReceiveMutationError = void
    export type InventoryLotsReceiveMutationVariables = {data: ReceiveLotDto}

    /**
 * @summary ثبت ورود کالا (خرید جدید)
 */
export const useInventoryLotsReceive = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof inventoryLotsReceive>>, TError,InventoryLotsReceiveMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof inventoryLotsReceive>>,
        TError,
        InventoryLotsReceiveMutationVariables,
        TContext
      > => {
      return useMutation(getInventoryLotsReceiveMutationOptions(options), queryClient);
    }
    /**
 * برای وقتی که همان سری (همان کد روی جعبه) دوباره خریده شده است. مقدار و مبلغ مثل ثبت ورود فرستاده می‌شوند. یک گردش PURCHASE با بهای همین خرید ثبت می‌شود، مقدار و مبلغ کل خرید سری بالا می‌رود و بهای هر واحد سری میانگین وزنی موجودی فعلی و خرید تازه می‌شود؛ مصرف‌های گذشته با بهای خودشان می‌مانند. به‌صورت پیش‌فرض یک هزینهٔ «خرید مواد» هم ثبت می‌شود. سری تاریخ‌گذشته پذیرفته نمی‌شود.
 * @summary افزودن خرید تازه به همین سری
 */
export const inventoryLotsReceiveMore = (
    id: string,
    receiveMoreLotDto: ReceiveMoreLotDto,
 signal?: AbortSignal
) => {


      return apiClient<LotResponse>(
      {url: `/api/v1/inventory/lots/${id}/receive-more`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: receiveMoreLotDto, signal
    },
      );
    }




export const getInventoryLotsReceiveMoreMutationKey = () => ['inventoryLotsReceiveMore'] as const;

export const getInventoryLotsReceiveMoreMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof inventoryLotsReceiveMore>>, TError,InventoryLotsReceiveMoreMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof inventoryLotsReceiveMore>>, TError,InventoryLotsReceiveMoreMutationVariables, TContext> => {

const mutationKey = getInventoryLotsReceiveMoreMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof inventoryLotsReceiveMore>>, InventoryLotsReceiveMoreMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  inventoryLotsReceiveMore(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type InventoryLotsReceiveMoreMutationResult = NonNullable<Awaited<ReturnType<typeof inventoryLotsReceiveMore>>>
    export type InventoryLotsReceiveMoreMutationBody = ReceiveMoreLotDto
    export type InventoryLotsReceiveMoreMutationError = void
    export type InventoryLotsReceiveMoreMutationVariables = {id: string;data: ReceiveMoreLotDto}

    /**
 * @summary افزودن خرید تازه به همین سری
 */
export const useInventoryLotsReceiveMore = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof inventoryLotsReceiveMore>>, TError,InventoryLotsReceiveMoreMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof inventoryLotsReceiveMore>>,
        TError,
        InventoryLotsReceiveMoreMutationVariables,
        TContext
      > => {
      return useMutation(getInventoryLotsReceiveMoreMutationOptions(options), queryClient);
    }
    /**
 * @summary جزئیات یک بچ
 */
export const inventoryLotsGetById = (
    id: string,
 signal?: AbortSignal
) => {


      return apiClient<LotResponse>(
      {url: `/api/v1/inventory/lots/${id}`, method: 'GET', signal
    },
      );
    }




export const getInventoryLotsGetByIdQueryKey = (id: string,) => {
    return [
    `/api/v1/inventory/lots/${id}`
    ] as const;
    }


export const getInventoryLotsGetByIdQueryOptions = <TData = Awaited<ReturnType<typeof inventoryLotsGetById>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof inventoryLotsGetById>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInventoryLotsGetByIdQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof inventoryLotsGetById>>> = ({ signal }) => inventoryLotsGetById(id, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof inventoryLotsGetById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type InventoryLotsGetByIdQueryResult = NonNullable<Awaited<ReturnType<typeof inventoryLotsGetById>>>
export type InventoryLotsGetByIdQueryError = void


export function useInventoryLotsGetById<TData = Awaited<ReturnType<typeof inventoryLotsGetById>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof inventoryLotsGetById>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof inventoryLotsGetById>>,
          TError,
          Awaited<ReturnType<typeof inventoryLotsGetById>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useInventoryLotsGetById<TData = Awaited<ReturnType<typeof inventoryLotsGetById>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof inventoryLotsGetById>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof inventoryLotsGetById>>,
          TError,
          Awaited<ReturnType<typeof inventoryLotsGetById>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useInventoryLotsGetById<TData = Awaited<ReturnType<typeof inventoryLotsGetById>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof inventoryLotsGetById>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary جزئیات یک بچ
 */

export function useInventoryLotsGetById<TData = Awaited<ReturnType<typeof inventoryLotsGetById>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof inventoryLotsGetById>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getInventoryLotsGetByIdQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * فقط اطلاعات توصیفی: شمارهٔ بچ، تاریخ انقضا، تأمین‌کننده، محل نگهداری و یادداشت. مقدار و مبلغ از این مسیر تغییر نمی‌کنند؛ برای آن‌ها سند گردش ثبت کنید.
 * @summary ویرایش اطلاعات بچ
 */
export const inventoryLotsUpdate = (
    id: string,
    updateLotDto: UpdateLotDto,
 signal?: AbortSignal
) => {


      return apiClient<LotResponse>(
      {url: `/api/v1/inventory/lots/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateLotDto, signal
    },
      );
    }




export const getInventoryLotsUpdateMutationKey = () => ['inventoryLotsUpdate'] as const;

export const getInventoryLotsUpdateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof inventoryLotsUpdate>>, TError,InventoryLotsUpdateMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof inventoryLotsUpdate>>, TError,InventoryLotsUpdateMutationVariables, TContext> => {

const mutationKey = getInventoryLotsUpdateMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof inventoryLotsUpdate>>, InventoryLotsUpdateMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  inventoryLotsUpdate(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type InventoryLotsUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof inventoryLotsUpdate>>>
    export type InventoryLotsUpdateMutationBody = UpdateLotDto
    export type InventoryLotsUpdateMutationError = void
    export type InventoryLotsUpdateMutationVariables = {id: string;data: UpdateLotDto}

    /**
 * @summary ویرایش اطلاعات بچ
 */
export const useInventoryLotsUpdate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof inventoryLotsUpdate>>, TError,InventoryLotsUpdateMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof inventoryLotsUpdate>>,
        TError,
        InventoryLotsUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getInventoryLotsUpdateMutationOptions(options), queryClient);
    }
    /**
 * مقدار شمرده‌شدهٔ هر سری فرستاده می‌شود و سرور اختلاف با موجودی را در یک تراکنش ثبت می‌کند. سری‌ای که با موجودی برابر است چیزی ثبت نمی‌کند.
 * @summary شمارش انبار (چند سری ساخت)
 */
export const inventoryLotsCount = (
    countLotsDto: CountLotsDto,
 signal?: AbortSignal
) => {


      return apiClient<LotCountResultResponse[]>(
      {url: `/api/v1/inventory/lots/count`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: countLotsDto, signal
    },
      );
    }




export const getInventoryLotsCountMutationKey = () => ['inventoryLotsCount'] as const;

export const getInventoryLotsCountMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof inventoryLotsCount>>, TError,InventoryLotsCountMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof inventoryLotsCount>>, TError,InventoryLotsCountMutationVariables, TContext> => {

const mutationKey = getInventoryLotsCountMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof inventoryLotsCount>>, InventoryLotsCountMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  inventoryLotsCount(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type InventoryLotsCountMutationResult = NonNullable<Awaited<ReturnType<typeof inventoryLotsCount>>>
    export type InventoryLotsCountMutationBody = CountLotsDto
    export type InventoryLotsCountMutationError = void
    export type InventoryLotsCountMutationVariables = {data: CountLotsDto}

    /**
 * @summary شمارش انبار (چند سری ساخت)
 */
export const useInventoryLotsCount = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof inventoryLotsCount>>, TError,InventoryLotsCountMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof inventoryLotsCount>>,
        TError,
        InventoryLotsCountMutationVariables,
        TContext
      > => {
      return useMutation(getInventoryLotsCountMutationOptions(options), queryClient);
    }
    /**
 * deltaMilli علامت‌دار است: مثبت یعنی افزودن، منفی یعنی کاستن. موجودی هرگز مستقیم «تنظیم» نمی‌شود، همیشه «تغییر» ثبت می‌شود — تنها شکلی که شش ماه بعد قابل توضیح است. دلیل اجباری است.
 * @summary اصلاح موجودی بچ
 */
export const inventoryLotsAdjust = (
    id: string,
    adjustLotDto: AdjustLotDto,
 signal?: AbortSignal
) => {


      return apiClient<LotResponse>(
      {url: `/api/v1/inventory/lots/${id}/adjust`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: adjustLotDto, signal
    },
      );
    }




export const getInventoryLotsAdjustMutationKey = () => ['inventoryLotsAdjust'] as const;

export const getInventoryLotsAdjustMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof inventoryLotsAdjust>>, TError,InventoryLotsAdjustMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof inventoryLotsAdjust>>, TError,InventoryLotsAdjustMutationVariables, TContext> => {

const mutationKey = getInventoryLotsAdjustMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof inventoryLotsAdjust>>, InventoryLotsAdjustMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  inventoryLotsAdjust(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type InventoryLotsAdjustMutationResult = NonNullable<Awaited<ReturnType<typeof inventoryLotsAdjust>>>
    export type InventoryLotsAdjustMutationBody = AdjustLotDto
    export type InventoryLotsAdjustMutationError = void
    export type InventoryLotsAdjustMutationVariables = {id: string;data: AdjustLotDto}

    /**
 * @summary اصلاح موجودی بچ
 */
export const useInventoryLotsAdjust = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof inventoryLotsAdjust>>, TError,InventoryLotsAdjustMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof inventoryLotsAdjust>>,
        TError,
        InventoryLotsAdjustMutationVariables,
        TContext
      > => {
      return useMutation(getInventoryLotsAdjustMutationOptions(options), queryClient);
    }
    /**
 * مقدار خالی یعنی کل باقی‌ماندهٔ سری. اگر تاریخ انقضای سری گذشته باشد گردش EXPIRY_WRITE_OFF («دورریز به‌دلیل انقضا») ثبت می‌شود، همان نوعی که کار شبانه ثبت می‌کند؛ وگرنه WASTAGE («ضایعات»). نوع از روی تاریخ سری تعیین می‌شود، نه از درخواست.
 * @summary ثبت دورریز سری
 */
export const inventoryLotsWriteOff = (
    id: string,
    writeOffLotDto: WriteOffLotDto,
 signal?: AbortSignal
) => {


      return apiClient<LotResponse>(
      {url: `/api/v1/inventory/lots/${id}/write-off`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: writeOffLotDto, signal
    },
      );
    }




export const getInventoryLotsWriteOffMutationKey = () => ['inventoryLotsWriteOff'] as const;

export const getInventoryLotsWriteOffMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof inventoryLotsWriteOff>>, TError,InventoryLotsWriteOffMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof inventoryLotsWriteOff>>, TError,InventoryLotsWriteOffMutationVariables, TContext> => {

const mutationKey = getInventoryLotsWriteOffMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof inventoryLotsWriteOff>>, InventoryLotsWriteOffMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  inventoryLotsWriteOff(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type InventoryLotsWriteOffMutationResult = NonNullable<Awaited<ReturnType<typeof inventoryLotsWriteOff>>>
    export type InventoryLotsWriteOffMutationBody = WriteOffLotDto
    export type InventoryLotsWriteOffMutationError = void
    export type InventoryLotsWriteOffMutationVariables = {id: string;data: WriteOffLotDto}

    /**
 * @summary ثبت دورریز سری
 */
export const useInventoryLotsWriteOff = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof inventoryLotsWriteOff>>, TError,InventoryLotsWriteOffMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof inventoryLotsWriteOff>>,
        TError,
        InventoryLotsWriteOffMutationVariables,
        TContext
      > => {
      return useMutation(getInventoryLotsWriteOffMutationOptions(options), queryClient);
    }
    /**
 * @summary برگشت کالا به تأمین‌کننده
 */
export const inventoryLotsReturnToSupplier = (
    id: string,
    returnLotDto: ReturnLotDto,
 signal?: AbortSignal
) => {


      return apiClient<LotResponse>(
      {url: `/api/v1/inventory/lots/${id}/return`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: returnLotDto, signal
    },
      );
    }




export const getInventoryLotsReturnToSupplierMutationKey = () => ['inventoryLotsReturnToSupplier'] as const;

export const getInventoryLotsReturnToSupplierMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof inventoryLotsReturnToSupplier>>, TError,InventoryLotsReturnToSupplierMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof inventoryLotsReturnToSupplier>>, TError,InventoryLotsReturnToSupplierMutationVariables, TContext> => {

const mutationKey = getInventoryLotsReturnToSupplierMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof inventoryLotsReturnToSupplier>>, InventoryLotsReturnToSupplierMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  inventoryLotsReturnToSupplier(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type InventoryLotsReturnToSupplierMutationResult = NonNullable<Awaited<ReturnType<typeof inventoryLotsReturnToSupplier>>>
    export type InventoryLotsReturnToSupplierMutationBody = ReturnLotDto
    export type InventoryLotsReturnToSupplierMutationError = void
    export type InventoryLotsReturnToSupplierMutationVariables = {id: string;data: ReturnLotDto}

    /**
 * @summary برگشت کالا به تأمین‌کننده
 */
export const useInventoryLotsReturnToSupplier = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof inventoryLotsReturnToSupplier>>, TError,InventoryLotsReturnToSupplierMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof inventoryLotsReturnToSupplier>>,
        TError,
        InventoryLotsReturnToSupplierMutationVariables,
        TContext
      > => {
      return useMutation(getInventoryLotsReturnToSupplierMutationOptions(options), queryClient);
    }
    /**
 * قرنطینه فقط وضعیت را عوض می‌کند و هیچ گردشی ثبت نمی‌کند: کالا هنوز روی قفسه و در دارایی کلینیک است، فقط قابل برداشت نیست. آزادسازی وضعیت را دوباره از روی تاریخ و موجودی محاسبه می‌کند، پس بچی که در قرنطینه منقضی شده باشد به وضعیت «منقضی» برمی‌گردد نه «فعال».
 * @summary قرنطینه یا آزادسازی بچ
 */
export const inventoryLotsSetQuarantine = (
    id: string,
    setLotQuarantineDto: SetLotQuarantineDto,
 signal?: AbortSignal
) => {


      return apiClient<LotResponse>(
      {url: `/api/v1/inventory/lots/${id}/quarantine`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: setLotQuarantineDto, signal
    },
      );
    }




export const getInventoryLotsSetQuarantineMutationKey = () => ['inventoryLotsSetQuarantine'] as const;

export const getInventoryLotsSetQuarantineMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof inventoryLotsSetQuarantine>>, TError,InventoryLotsSetQuarantineMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof inventoryLotsSetQuarantine>>, TError,InventoryLotsSetQuarantineMutationVariables, TContext> => {

const mutationKey = getInventoryLotsSetQuarantineMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof inventoryLotsSetQuarantine>>, InventoryLotsSetQuarantineMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  inventoryLotsSetQuarantine(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type InventoryLotsSetQuarantineMutationResult = NonNullable<Awaited<ReturnType<typeof inventoryLotsSetQuarantine>>>
    export type InventoryLotsSetQuarantineMutationBody = SetLotQuarantineDto
    export type InventoryLotsSetQuarantineMutationError = void
    export type InventoryLotsSetQuarantineMutationVariables = {id: string;data: SetLotQuarantineDto}

    /**
 * @summary قرنطینه یا آزادسازی بچ
 */
export const useInventoryLotsSetQuarantine = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof inventoryLotsSetQuarantine>>, TError,InventoryLotsSetQuarantineMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof inventoryLotsSetQuarantine>>,
        TError,
        InventoryLotsSetQuarantineMutationVariables,
        TContext
      > => {
      return useMutation(getInventoryLotsSetQuarantineMutationOptions(options), queryClient);
    }
